/**
 * Available seo's data of customer.
 */
export const CustomerSEO = {
  baseTitle: 'Музыканты России',
  baseDescription: 'Description'
};
